<h2 mat-dialog-title>Use your existing login</h2>

<mat-dialog-content class="tw-max-w-md">
  <p class="tw-m-0 tw-text-sm tw-leading-relaxed tw-text-gray-300">
    Sign in to gotlivedata.com with your existing Workforce login — no new account needed.
  </p>
  <p class="tw-mt-3 tw-mb-0 tw-text-sm tw-leading-relaxed tw-text-gray-300">
    Your chats, saved lists and searches will be waiting.
  </p>
</mat-dialog-content>

<mat-dialog-actions align="end" class="tw-p-4 tw-gap-2">
  <button mat-button mat-dialog-close>Not now</button>
  <button
    type="button"
    (click)="goToNewDomain()"
    class="tw-inline-flex tw-items-center tw-gap-2 tw-bg-[#7FFFD4] hover:tw-bg-[#A9FFE3] tw-text-[#0C2A21] tw-text-sm tw-font-semibold tw-px-4 tw-py-2 tw-rounded-lg tw-whitespace-nowrap tw-transition-colors">
    Continue to gotlivedata.com
    <span aria-hidden="true">→</span>
  </button>
</mat-dialog-actions>
